import { render, staticRenderFns } from "./DetailLeft.vue?vue&type=template&id=1bc1c892&scoped=true&"
import script from "./DetailLeft.vue?vue&type=script&lang=js&"
export * from "./DetailLeft.vue?vue&type=script&lang=js&"
import style0 from "./DetailLeft.vue?vue&type=style&index=0&id=1bc1c892&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc1c892",
  null
  
)

export default component.exports